<template>
  <div class="nkn-news">
    <div class="body-container">
      <div class="common-title">{{$t("news.title")}}</div>
      <news-social></news-social>
      <news-youtube></news-youtube>
    </div>
  </div>
</template>

<script>
import NewsSocial from '@/components/news/nknSocialMedia'
import NewsYoutube from '@/components/news/nknYoutube'
import $ from 'jquery'

export default {
  components: {
    NewsSocial, NewsYoutube
  },
  mounted () {
    this.$nextTick(_ => {
      $('<script async src="https://platform.twitter.com/widgets.js" charset="utf-8"><\/script>').appendTo($('body'))
    })
  },
  metaInfo() {
    if (this.$i18n.locale === 'zh') {
      return {
        title: '新闻门户',
        // titleTemplate: '%s - by vue-meta',
        htmlAttrs: {
          lang: this.$i18n.locale
        },
        attribute: '',
        meta: [
          {name: 'keywords', content: 'NKN,nkn,P2P,Network,BlockChain'},
          {
            name: 'description',
            content: '最新NKN新闻、视频和新媒体报道。'
          }
        ]
      }
    } else {
      return {
        title: 'NKN News | The New Kind of Network',
        // titleTemplate: '%s - by vue-meta',
        htmlAttrs: {
          lang: this.$i18n.locale
        },
        meta: [
          {name: 'keywords', content: 'NKN,nkn,P2P,Network,BlockChain'},
          {
            name: 'description',
            content: 'Explore our news page to find social media updates, topic discussions, industry news, NKN bi-weekly reports, and links to our NKN AMA schedules.'
          }
        ]
      }
    }

  }
}
</script>

<style lang="scss" scoped>
.nkn-news{
  @include common-inner();
}
</style>



// WEBPACK FOOTER //
// src/views/NewsPortal.vue